import { render, staticRenderFns } from "./DateTimeSection.vue?vue&type=template&id=b21a709a&scoped=true&"
import script from "./DateTimeSection.vue?vue&type=script&lang=js&"
export * from "./DateTimeSection.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/assignment_dates.css?vue&type=style&index=0&id=b21a709a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21a709a",
  null
  
)

export default component.exports